<template>
	<div>
		<!-- <h2 class="title">Buat Supplier Baru</h2> -->
		<form>
			<div class="row row-space">
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<div class="input-group">
						<label class="label"
							>Nama<span style="color: red;">*</span></label
						>
						<input
							class="input--style-4"
							type="text"
							name="name"
							v-model="form.name"
							placeholder="Ketik Nama Supplier"
						/>
					</div>
				</div>
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<div class="input-group">
						<label class="label"
							>Nomor Telepon<span style="color: red;"
								>*</span
							></label
						>
						<input
							class="input--style-4"
							type="text"
							name="phone"
							v-model="form.phone_number"
							placeholder="Ketik Nomor Telepon Supplier"
						/>
					</div>
				</div>
			</div>
			<div class="row row-space">
				<div class="col-xs-12 col-md-6">
					<div class="input-group">
						<label class="label"
							>Email<span style="color: red;">*</span></label
						>
						<input
							class="input--style-4"
							type="text"
							name="address"
							v-model="form.email"
							placeholder="Ketik Email Supplier"
						/>
					</div>
				</div>
				<div class="col-xs-12 col-md-6">
					<div class="input-group">
						<label class="label"
							>Alamat<span style="color: red;">*</span></label
						>
						<input
							class="input--style-4"
							type="text"
							name="address"
							v-model="form.address"
							placeholder="Ketik Alamat Supplier"
						/>
					</div>
				</div>
			</div>
			<div class="row row-space">
				<div class="col-xs-12 col-md-6">
					<div class="input-group">
						<label class="label"
							>Nama Bank<span style="color: red;">*</span></label
						>
						<input
							class="input--style-4"
							type="text"
							name="address"
							v-model="form.bank_name"
							placeholder="Ketik Email Supplier"
						/>
					</div>
				</div>
				<div class="col-xs-12 col-md-6">
					<div class="input-group">
						<label class="label"
							>Nomor Rekening Bank<span style="color: red;"
								>*</span
							></label
						>
						<input
							class="input--style-4"
							type="text"
							name="address"
							v-model="form.bank_account"
							placeholder="Ketik Alamat Supplier"
						/>
					</div>
				</div>
			</div>
			<div class="row row-space">
				<div class="col-12">
					<div class="input-group">
						<label class="label"
							>Atas Nama Rekening<span style="color: red;"
								>*</span
							></label
						>
						<input
							class="input--style-4"
							type="text"
							name="address"
							v-model="form.bank_account_name"
							placeholder="Ketik Email Supplier"
						/>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col mt-5" style="text-align: center">
					<button
						type="button"
						class="btn btn-outline-danger"
						style="font-size:140%"
						@click="$emit('closeModal')"
					>
						Kembali
					</button>
					<button
						type="button"
						class="btn btn-primary ml-5"
						style="font-size:150%"
						@click="submitForm()"
					>
						Buat
					</button>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import MultiSelect from "vue-multiselect";

export default {
	data() {
		return {
			form: {
				name: "",
				phone_number: "",
				address: "",
				email: "",
				bank_account: "",
				bank_name: "",
				bank_account_name: "",
			},
		};
	},
	components: {
		MultiSelect,
	},
	mounted() {},
	watch: {},
	methods: {
		validateForm() {
			var valid = true;
			var error = [];

			if (this.form.name == "" || this.form.name == null) {
				//Name [Required]
				valid = false;
				error.push("Nama wajib diisi!");
			}

			if (
				this.form.phone_number == "" ||
				this.form.phone_number == null
			) {
				//Phone Number [Required]
				valid = false;
				error.push("Nomor Telepon wajib diisi!");
			}
			if (!isNaN(this.phone_number)) {
				//Phone Number not number
				valid = false;
				error.push("Nomor Telepon Hanya Dapat Diisi Dengan Nomor!");
			}

			if (this.form.address == "" || this.form.address == null) {
				//Address [Required]
				valid = false;
				error.push("Alamat wajib diisi!");
			}
			if (this.form.email == "" || this.form.email == null) {
				//Address [Required]
				valid = false;
				error.push("Email wajib diisi!");
			}
			if (
				this.form.bank_account == "" ||
				this.form.bank_account == null
			) {
				//Address [Required]
				valid = false;
				error.push("Nomor Rekening wajib diisi!");
			}
			if (
				this.form.bank_account_name == "" ||
				this.form.bank_account_name == null
			) {
				//Address [Required]
				valid = false;
				error.push("Atas Nama Rekening wajib diisi!");
			}
			if (this.form.bank_name == "" || this.form.bank_name == null) {
				//Address [Required]
				valid = false;
				error.push("Nama Bank wajib diisi!");
			}

			if (!valid) this.$store.dispatch("triggerAlert", [false, error]);
			else return valid;
		},
		async submitForm() {
			let vm = this;
			if (vm.validateForm()) {
				this.$http
					.post("/api/v1/masterData/supplier", this.form)
					.then((resp) => {
						// alert(`Partshop ${vm.form.name} has been created`);
						this.$store.dispatch("triggerAlert", [
							true,
							[`Supplier ${vm.form.name} telah berhasil dibuat`],
						]);
						this.$emit('supplierData' , resp.data.data);
						this.$emit("closeModal");
					})
					.catch((err) => {
						console.log(err);
						this.$store.dispatch("triggerAlert", [
							false,
							String(err)
								.split("Error:")[1]
								.split("; "),
						]);
					});
			}
		},
	},
};
</script>

<style scoped>
/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
	outline: none;
	margin: 0;
	border: none;
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
	width: 100%;
	font-size: 14px;
	font-family: inherit;
}

.input--style-4 {
	line-height: 50px;
	background: #fafafa;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	border-radius: 5px;
	padding: 0 20px;
	font-size: 16px;
	color: #666;
	-webkit-transition: all 0.4s ease;
	-o-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
	transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
	/* WebKit, Blink, Edge */
	color: #666;
}

.input--style-4:-moz-placeholder {
	/* Mozilla Firefox 4 to 18 */
	color: #666;
	opacity: 1;
}

.input--style-4::-moz-placeholder {
	/* Mozilla Firefox 19+ */
	color: #666;
	opacity: 1;
}

.input--style-4:-ms-input-placeholder {
	/* Internet Explorer 10-11 */
	color: #666;
}

.input--style-4:-ms-input-placeholder {
	/* Microsoft Edge */
	color: #666;
}

.label {
	font-size: 16px;
	color: #555;
	text-transform: capitalize;
	display: block;
	margin-bottom: 5px;
}

.radio-container {
	display: inline-block;
	position: relative;
	padding-left: 30px;
	cursor: pointer;
	font-size: 16px;
	color: #666;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.radio-container input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
	background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
	display: block;
}

.radio-container .checkmark:after {
	top: 50%;
	left: 50%;
	-webkit-transform: translate(-50%, -50%);
	-moz-transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%);
	-o-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	width: 12px;
	height: 12px;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	background: #57b846;
}

.checkmark {
	position: absolute;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	left: 0;
	height: 20px;
	width: 20px;
	background-color: #e5e5e5;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}

.input-group {
	position: relative;
	/* margin-bottom: 22px; */
	padding: 20px;
}

.input-group-icon {
	position: relative;
}

.input-icon {
	position: absolute;
	font-size: 18px;
	color: #999;
	right: 18px;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
	font-size: 40px;
	color: #525252;
	margin-bottom: 40px;
	text-align: center;
}
</style>
